import { defineComponent as _defineComponent } from 'vue'
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import { useBilling } from '@/components/Billing/Billing.composables';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPriceMapDialog',
  props: {
    title: null,
    priceMap: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	title: String;
	priceMap: { [key: number]: number };
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}


const { isAnnuallyPlan } = useBilling();

const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, isAnnuallyPlan, close, AppDialog }
}

})